import {Route, RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {ElementGroupFormComponent} from './element-group-form/element-group-form.component';
import {ElementGroupResolverService} from './services/element-group.resolver.service';
import {ElementGroupNtdDefaultParamsResolverService} from './services/element-group-ntd-default-params.resolver.service';
import {ElementGroupNtdListResolverService} from './services/element-group-ntd-list.resolver.service';
import {ElementGroupTypesDefaultListResolverService} from './services/element-group-types-default-list.resolver.service';
import {ElementGroupTypesDefaultParamsResolverService} from './services/element-group-types-default-params.resolver.service';
import {ElementGroupTechnicalDeviceResolverService} from './services/element-group-technical-device.resolver.service';
import {ElementGroupTechnicalCardsDefaultListResolverService} from './services/element-group-technical-cards-default-list.resolver.service';


export const elementGroupRoutes: Route[] = [
    {
        path: ':technicalDeviceId/new',
        component: ElementGroupFormComponent,
        resolve: {
            ntdList: ElementGroupNtdListResolverService,
            technicalDevice: ElementGroupTechnicalDeviceResolverService,
        },
    },
    {
        path: ':id',
        resolve: {
            data: ElementGroupResolverService,
        },
        children: [
            {
                path: 'edit',
                component: ElementGroupFormComponent,
                resolve: {
                    technicalDevice: ElementGroupTechnicalDeviceResolverService,
                    ntdList: ElementGroupNtdListResolverService,
                    ntdParams: ElementGroupNtdDefaultParamsResolverService,
                    typesList: ElementGroupTypesDefaultListResolverService,
                    techCardsList: ElementGroupTechnicalCardsDefaultListResolverService,
                    typeParams: ElementGroupTypesDefaultParamsResolverService,
                }
            }
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(elementGroupRoutes)
    ],
    exports: [
        RouterModule,
    ],
    declarations: [],
    providers: [],
})
export class ElementGroupRoutingModule {
}
